import dayjs from 'dayjs'

/**
 * Get exact local date from date string regardless of timezone
 * @param dateString The input date string in YYYY-MM-DD format
 */
export const getLocalDate = (dateString: string): Date | undefined => {
  if (!dateString) {
    return
  }

  const [year, month, day] = dateString.split('-')
  return new Date(+year, +month - 1, +day)
}

/**
 * Get UTC date string of the day from date object or string
 * @param date The input date object or string in YYYY-MM-DD format
 * @returns The UTC date string in YYYY-MM-DDT00:00:00Z format
 */
export const getUtcDateString = (date: Date | string, format?: string): string => {
  if (typeof date === 'string') {
    if (!/\d{4}-\d{2}-\d{2}/.test(date)) {
      throw new Error('The date input must be in YYYY-MM-DD format')
    }
    return dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]')
  }

  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  return dayjs()
    .year(year)
    .month(month)
    .date(day)
    .hour(0)
    .minute(0)
    .second(0)
    .format(format ?? 'YYYY-MM-DDTHH:mm:ss[Z]')
}
